import Url from '@music/mobile-url';
import {makeActionCreator, makeActionType, getActionType, TYPES} from '../util/redux';
import Request from '../util/fetch';
import {Toast} from '../component/message';
export const UserType = 'user';
//创建Types
makeActionType(UserType, ['lgoutrequest', 'lgoutcomplete', 'saveformele', 'messagecount', 'agreecomp', 'setcustomwm','cashEncourageStateSuccess','cashEncourageStateFail']);
export const userSuccess = makeActionCreator(getActionType(UserType, 'success'));
export const userFail = makeActionCreator(getActionType(UserType, 'fail'));
export const cashEncourageStateSuccess = makeActionCreator(getActionType(UserType, 'cashEncourageStateSuccess'));
export const cashEncourageStateFail = makeActionCreator(getActionType(UserType, 'cashEncourageStateFail'));
export const userLogoutComplete = makeActionCreator(getActionType(UserType, 'lgoutcomplete'));
export const userSaveForm = makeActionCreator(getActionType(UserType, 'saveformele'));
export const userMessageCount = makeActionCreator(getActionType(UserType, 'messagecount'));
export const agreeComp = makeActionCreator(getActionType(UserType, 'agreecomp'));
export const setCustomWm = makeActionCreator(getActionType(UserType, 'setcustomwm'));

const mockUserId = Url.CurrentParams.mockUserId || '';

//获取用户登录信息
export const userRequest = () => (dispatch) => {
    dispatch({
        type : getActionType(UserType, 'request')
    });
    return Request.fetch({
        url : "api/cloudvideo/user/info/get",
        method : 'post',
        data : {
            mockUserId
        }
    })
    .then(function(result){
        dispatch(userSuccess(result));
    })
    .catch(error => {
        let rerr = Request.resolveError(error);
        dispatch(userFail(rerr))
    });
}

//获取用户参与现金激励个人版，公司版的情况
export const cashEncourageStateRequest = () => (dispatch) => {
  return Request.fetch({
    url : "/api/cloudvideo/activity/moneyexcite/userstate",
  })
    .then(function(result){
      dispatch(cashEncourageStateSuccess(result));
    })
    .catch(error => {
      let rerr = Request.resolveError(error);
      Toast({
        type: 'error',
        text: rerr.msg || '请求失败，请重试'
      });
      dispatch(cashEncourageStateFail(rerr));
    });
}

//记录用户是否同意协议
export const agreeRequest = () => (dispatch) => {
    dispatch(agreeComp({success : true}));
    return Request.fetch({
        url : "api/cloudvideo/user/agreement/publish/confirm",
        method : 'post',
        data : {
            mockUserId
        }
    })
    .then(function(result){
        //dispatch(agreeComp({success : true}));
    })
    .catch(error => {
        //dispatch(agreeComp({success : true}));
    });
}
//退出登录
export const userLogoutRequest = () => (dispatch) => {
    dispatch({
        type : getActionType(UserType, 'lgoutrequest')
    });
    return Request.fetch({
        url : "/logout",
        method : 'get'
    })
    .then(function(data){
        dispatch(userLogoutComplete(data));
        dispatch({
            type : TYPES.CLEAR_ALL
        });
        location.href = '/login?targetUrl=' + encodeURIComponent(location.href);
    })
    .catch(error => {
        let rerr = Request.resolveError(error);
        Toast({
            type : 'error',
            text : rerr.msg
        });
        dispatch(userLogoutComplete())
    });
}
//私信数量
export const userMessageRequest = () => (dispatch) => {
    return Request.fetch({
        url : "api/pl/count",
        method : 'get'
    })
    .then(function(data){
        dispatch(userMessageCount(data));
    })
    .catch(error => {
        //console.log(error);
    });
}
//点击tab 去除红点
export const userRedDotRequest = (type) => (dispatch) => {
    return Request.fetch({
        url : "api/cloudvideo/app/promotion/resource/click",
        method : 'post',
        data: {
            type: type
        }
    })
    .then(function(data){
        dispatch(userRequest());
    })
    .catch(error => {
        dispatch(userRequest());
        //console.log(error);
    });
}


// WEBPACK FOOTER //
// ./client/action/user.js